export const SMS_PROVIDER = {
  NOT_SET: 'SMS_PROVIDER_NOT_SET',
  TWILIO: 'SMS_PROVIDER_TWILIO',
  INFOBIP: 'SMS_PROVIDER_INFOBIP',
} as const

export type SmsProvider = typeof SMS_PROVIDER[keyof typeof SMS_PROVIDER]
